import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/migration/migration-data-grid-v5/migration-data-grid-v5.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
